<template>
    <div class="container">
        <!-- <div class="fixed-cards">
            <el-card v-for="item in tableData" :key="item.shopName" shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>基础信息:</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8"><strong>二维码名称:</strong> {{ item.qrcodeName }}</el-col>
                        <el-col :span="8"><strong>商品名称:</strong> {{ item.goodsName }}</el-col>
                        <el-col :span="8"><strong>所属商户:</strong> {{ item.shopName }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8"><strong>客户姓名:</strong> {{ item.userName }}</el-col>
                        <el-col :span="8"><strong>客户电话:</strong> {{ item.mobile }}</el-col>
                        <el-col :span="8"><strong>客户地址:</strong> {{ item.address }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8"><strong>服务工程师:</strong> {{ item.receiver }}</el-col>
                        <el-col :span="8"><strong>服务工程师电话:</strong> {{ item.account }}</el-col>
                        <el-col :span="8"><strong>服务状态:</strong> <el-tag v-if="item.status == 'DONE'" type="success"> {{
                            getStatusLabel(item.status) }}</el-tag>
                            <el-tag v-else-if="item.status == '2'" type="WAIT_PAY"> {{ getStatusLabel(item.status)
                                }}</el-tag>
                            <el-tag v-else-if="item.status == '3'" type="RETURNED"> {{ getStatusLabel(item.status)
                                }}</el-tag>
                            <el-tag v-else>{{ getStatusLabel(item.status) }}</el-tag>
                        </el-col>
                    </el-row>
                    <div v-if="item.imageUrl" class="form-row">
                        <p><strong>图片:</strong>
                            <viewer :images="formmaterImage(item.imageUrl)">
                                <img v-for="src in formmaterImage(item.imageUrl)" :src="src" :key="src"
                                    class="card-image" />
                            </viewer>
                        </p>
                    </div>
                </div>
            </el-card>
        </div> -->
        <div class="fixed-cards">
            <el-card shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>客户评价详情:</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col v-for="column in dynamicColumns" :key="column.id"
                            style="display: flex;align-items: center;text-align: center;"
                            :span="getSpan(dynamicColumns.length)">
                            <strong>{{ column.fieldName }}:</strong>
                            <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{ column.fieldValue
                                }}</span>
                            <!-- 评分星级 -->
                            <span v-else-if="column.inputType === 'star'"
                                style="display: flex;align-items: center;text-align: center;">
                                <el-rate v-model="column.fieldValue" disabled></el-rate>
                                <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                                    column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' : column.fieldValue
                                    == '5' ? '非常好' : ''}}</span>
                            </span>
                            <span v-else><time>{{ column.fieldValue }}</time></span>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
        <div class="dynamic-cards" v-if="imageFields.length > 0">
            <el-card shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>工单清单图片信息:</span>
                </div>
                <div class="form-row" v-for="column in imageFields" :key="column.id">
                    <p class="gap-line-border" v-if="column.inputType === 'img'">
                        <span class="nameStyle">{{ column.fieldName }}:</span>
                        <span class="gap-line"></span>
                        <span v-if="column.fieldValue">
                            <viewer :images="formmaterImage(column.fieldValue)">
                                <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                    class="card-image" />
                            </viewer>
                        </span>
                        <span v-else>暂无图片</span>
                    </p>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { DIC } from "@/const/dic";

export default {
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
        };
    },
    created() {
        // 获取动态控件类型
        findDataSourceFields().then(res => {
            let data = JSON.parse(res.data);
            this.inputTypes = data;

            // 获取产品数据
            const goodsId = this.$route.query.GoodsId; // 假设产品ID通过路由参数传递
            if (goodsId) {
                this.fetchGoodsData(goodsId);
            }
        }).catch(err => {
            this.$message.error('获取动态控件类型失败', err);
        });
    },
    methods: {
        fetchGoodsData(goodsId) {
            const params = {
                id: goodsId,
                code: 'WATER_PURIFICATION_QUESTIONNAIRE'
            };
            // 获取产品数据
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;

                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }

    .form-row {
        flex-direction: column;
    }

    .form-row p {
        min-width: 100%;
        /* 小屏幕下每行一个内容 */
    }
}
</style>